// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

const ReservedWrapper = styled<any, Theme>('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 1.2rem;
  color: white;
`;

export default ReservedWrapper;
